import React from 'react'
import { Link } from "react-router-dom";
import { Button } from "@mui/material";

import "./SuccessStory.css";

function SuccessStory() {
  return (
    <div className='succMn'>
        <div className="maxW">
            <div className="sucCon">
                <h2>Every growth story begins by <br></br>
                  simplifying solutions — let’s talk.</h2>
                <p>At Paytech Advisors, every conversation is an opportunity to understand your vision and explore how we can help your business grow.
                 Whether you’re looking for tailored payment solutions, strategic consultancy, or innovative technology, our team is here to guide you every step of the way.
</p>

    <Button
              variant="contained"
              component={Link}
              to="/contact-us"
              className="swbtnLink"
            >
           Contact Us
            </Button>
            </div>
        </div>
    </div>
  )
}

export default SuccessStory